import React from 'react';
import { Heading, Subheading } from 'components/src/typography';
import TextInput from 'components/src/textInput/TextInput';
import { CardCollection, TabGroupFieldsFragment } from 'types/generated';
import { renderAllCards, renderTabContent } from '../Tabs/Tabs';
import { getOr } from '@/utils/options';
import Tab, { Tabs, TabPanel } from 'components/src/tab';
import { Cards2f1FieldsFragment } from 'types/generated';
import ModalCard from './ModalCard';

type Props = {
  data: TabGroupFieldsFragment;
};

const TveirFyrirEinn = ({ data }: Props) => {
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [searchCompany, setSearchCompany] = React.useState('');

  const tabs = data.tabsCollection?.items;

  const allItems = React.useMemo(() => {
    const maxTabs = Math.max(
      ...(tabs?.map<number>((t) => {
        if (t?.content?.__typename !== 'CardCollection') {
          return 0;
        }
        return t.content.cardCollection?.items.length || 0;
      }) || [])
    );
    const cards = [] as Cards2f1FieldsFragment[];
    for (let cardIndex = 0; cardIndex < maxTabs; cardIndex++) {
      // Reverse order due to requirements from business folks
      for (let tabIndex = (tabs?.length || 0) - 1; tabIndex >= 0; tabIndex--) {
        if (tabs && tabs[tabIndex]?.content?.__typename === 'CardCollection') {
          const items = (tabs[tabIndex]?.content as CardCollection).cardCollection?.items;
          if (items && items.length > cardIndex) {
            cards.push(items[cardIndex] as Cards2f1FieldsFragment);
          }
        }
      }
    }
    return cards.filter((c) => {
      const companyName = c.companyName || '';
      return companyName.toLowerCase().includes(searchCompany.toLowerCase());
    });
  }, [tabs, searchCompany]);

  const handleChangeTab = (newTabIndex: number) => {
    setSearchCompany('');
    setSelectedIndex(newTabIndex);
  };

  return (
    <div className="col-span-full pt-100">
      <ModalCard />
      <div className={`mb-64 flex flex-col items-center gap-y-[60px]`}>
        <Heading variant="xl" classes="text-black-50">
          {'Tilboðin okkar'}
        </Heading>
        <div className="w-full md:w-[684px]">
          <TextInput
            id={'leita-tilbod'}
            placeholder={'Leita að samstarfsaðila'}
            type={'text'}
            onChange={(value) => {
              setSelectedIndex(0);
              setSearchCompany(value);
            }}
            value={searchCompany}
            icon={'search'}
          />
        </div>
      </div>
      <Tabs>
        <Tab
          index={0}
          label={getOr(data.showAllTitle, 'Öll tilboð')}
          buttonLabelClasses="!font-normal"
          buttonClasses="!px-4"
          selected={selectedIndex === 0}
          onClick={handleChangeTab}
        />
        {tabs &&
          tabs.length > 1 &&
          tabs?.map((tab, index) => {
            return (
              <Tab
                key={`${tab?.title}-${index}`}
                index={index + 1}
                label={getOr(tab?.title, '')}
                buttonLabelClasses="!font-normal"
                buttonClasses="!px-4"
                selected={selectedIndex === index + 1}
                onClick={handleChangeTab}
              />
            );
          })}
      </Tabs>
      <TabPanel value={selectedIndex} index={0}>
        {allItems && allItems?.length > 0 ? (
          renderAllCards(allItems)
        ) : (
          <div className="col-span-full mt-64 flex justify-center">
            <Subheading>{'Fyrirtæki fannst ekki'}</Subheading>
          </div>
        )}
      </TabPanel>
      {tabs?.map((tab, index) => {
        return (
          <TabPanel key={`${tab?.title}-${index}`} value={selectedIndex} index={index + 1}>
            {renderTabContent(tab)}
          </TabPanel>
        );
      })}
    </div>
  );
};
export default TveirFyrirEinn;
